$(() => {
	document.querySelectorAll('form.contract-form').forEach((form) => {
		const initialTab = 0;
		const formId = form.id;
		const store = new handleTabSwitch(form);
		const {
			state, previousTab, nextTab, getTab, updateNavigationButtons,
		} = store;

		const persistCurrentForm = () => {
			persistForm(formId, state.furthestTab, getFormData(form));
		}

		updateNavigationButtons(getTab(initialTab));

		// Handle form submission
		form.addEventListener('submit', async (event) => {
			await handleSubmit(event, store)
		});

		form.querySelectorAll('input[role="spinbutton"]').forEach((spinbutton) => {
			spinbutton.addEventListener('input', (event) => {
				const el = event.currentTarget;
				if (el.value !== '') {
					el.value = Math.floor(parseFloat(el.value));
					el.blur()
					el.focus();
					el.dispatchEvent(new Event("change"));
				}
			});
		});

		// Handle file upload via dropzone
		form.querySelectorAll('fieldset.field--filefield').forEach((filefield) => {
			setupDropzone(filefield, persistCurrentForm);
		});

		form.querySelectorAll('[data-fetch-on-blur]').forEach((input) => {
			setupFetchOnBlur(input, form);
		});


		form.querySelectorAll('[data-autofill-trigger]').forEach((input) => {
			setupAutofill(input, form);
		});

		// // Handle file upload via dropzone
		// form.querySelectorAll('fieldset.field--autocompletefield').forEach((autocompletefield) => {
		// 	setupAutocomplete(autocompletefield, form);
		// });

		form.querySelectorAll('[data-autocomplete-root]').forEach((rootInput) => {
			const group = new AutocompleteGroup(rootInput, form);
			const CACHE_KEY = `autocomplete-groups`;
			const cachedGroups = cache().getItem(CACHE_KEY) ?? {};
			cachedGroups[rootInput.name] = group;
			cache().setItem(CACHE_KEY, cachedGroups);
		});

		// Handle showing fields conditionally
		refreshConditionalRelatedElements(form);
		form.querySelectorAll('[data-show-if]').forEach((groupElement) => {
			const parsedGroupData = parseConditionalGroup(groupElement);
			const handledGroupSelectors = getGroupSelectors(parsedGroupData, form);

			handledGroupSelectors.forEach((element) => {
				let eventListenerType = 'input';
				if (element.nodeName === 'INPUT' && ['radio', 'checkbox'].includes(element?.type)) {
					eventListenerType = 'change';

					if (element?.type === 'radio') {
						Array.from(form.querySelectorAll(`[name="${element.name}"]`))
						.filter((input) => input !== element)
						.forEach((input) => {
							input.addEventListener(eventListenerType, () => {
								updateGroupVisibility(parsedGroupData, groupElement, form);
							})
						})
					}
				}
				element.addEventListener(eventListenerType, () => {
					updateGroupVisibility(parsedGroupData, groupElement, form);
				});
			})
		})

		// Handle increment/decrement spinbutton
		form.querySelectorAll('.spinbutton-field button[data-action]').forEach((button) => {
			button.addEventListener('click', () => {
				const action = button.dataset?.action;
				const input = document.getElementById(button.getAttribute('aria-controls'));
				if (action && input) {
					action === 'increment' && input.stepUp();
					action === 'decrement' && input.stepDown();
				} else {
					console.error('Spinbutton error', { action, input });
				}
			})
		})

		// Expand/collapse checkboxes content
		form.querySelectorAll('button.expand-description').forEach((button) => {
			button.addEventListener('click', () => {
				const isExpanded = button.getAttribute('aria-expanded') === 'true';
				const description = document.getElementById(button.getAttribute('aria-controls') ?? '');

				if (description) {
					if (isExpanded) {
						button.setAttribute('aria-expanded', 'false');
						$(description).stop().slideUp(200);
					} else {
						button.setAttribute('aria-expanded', 'true');
						$(description).stop().slideDown(200);
					}
				}
			})
		})

		// Handle prev/next tab button click
		form.querySelector('button.form-navigation-button[data-action="previous-tab"]').addEventListener('click', previousTab);
		form.querySelector('button.form-navigation-button[data-action="next-tab"]').addEventListener('click', nextTab);

		// Handle form reset button click
		form.querySelector('button.form-navigation-button[data-action="reset"]').addEventListener('click', async () => {
			await resetForm(form, store);
		});
		// Handle form save to localStorage
		form.querySelector('button.form-navigation-button[data-action="persist"]').addEventListener('click', (event) => {
			const button = event.currentTarget;
			if (button.disabled) return;

			const textElement = button.querySelector('span.text');
			const currentText = textElement.textContent;

			button.disabled = true;
			textElement.textContent = 'Zapisywanie...';
			setTimeout(() => {
				button.disabled = false;
				textElement.textContent = currentText;
				persistCurrentForm();
			}, 750);
		});
		// Disable form if switching tabs
		$(form.querySelectorAll('.primary-nav-tabs>button')).on('show.bs.tab shown.bs.tab', (event) => {
			const eventType = event.type;
			form.querySelectorAll('button.form-navigation-button').forEach((button) => {
				button.disabled = eventType === 'show';
			});
			if (eventType === 'shown') {
				form.scrollIntoView();
			}
		});


		// Handle discount check
		form.querySelectorAll('.field--discountfield button.check-discount-code').forEach((button) => {
			const fieldset = getFieldset(button);
			const input = fieldset.querySelector('input.input--discountfield');
			handleDiscountButtonDisability(input);
			input.addEventListener('input', () => handleDiscountButtonDisability(input))
			button.addEventListener('click', async () => {
				await validateDiscountCode(input);
			})
		})


		const allAddableTabsNavButtons = form.querySelectorAll('.addable-nav-tabs>button[role="tab"]');
		updateAddableNavTabsDisability(allAddableTabsNavButtons);
		form.querySelectorAll('.addable-nav-tabs > button.add-addable-tab').forEach((button) => {
			button.addEventListener('click', (event) => {
				handleAddAddableTab(event);
				persistCurrentForm()
			});
		});
		form.querySelectorAll('.addable-nav-tabs span.remove-addable-tab').forEach((button) => {
			button.addEventListener('click', (event) => {
				handleRemoveAddableTab(event);
				persistCurrentForm()
			});
		});


		// Initialize tooltips
		$(form.querySelectorAll('i.tooltip-element')).tooltipster({
			maxWidth: 510,
			contentAsHTML: true,
			contentCloning: true,
			interactive: true,
			side: ['right', 'left', 'top', 'bottom'],
			theme: 'contract-form-tooltip',
			functionInit(instance) {
				const $content = instance.content();
				const $tooltipContentSwiper = $content.find('.tooltip-swiper');
				if ($tooltipContentSwiper.length) {
					const swiperContainer = $tooltipContentSwiper[0];
					new Swiper(swiperContainer, {
						spaceBetween: 30,
						loop: true,
						// autoHeight: true,
						observer: true,
						observeParents: true,
						pagination: {
							el: swiperContainer.querySelector('.swiper-pagination'),
							type: 'bullets',
							clickable: true
						},
						on: {
							slideChange() {
							}
						}
					});
				}
			},
			functionReady(instance) {
				const $content = instance.content();
				const $tooltipContentSwiper = $content.find('.tooltip-swiper');
				if ($tooltipContentSwiper.length) {
					const swiperContainer = $tooltipContentSwiper.get(0);
					swiperContainer?.swiper?.update();
				}
			},
		});

		const datePickerArrow = `<svg xmlns="http://www.w3.org/2000/svg" width="11" height="14" viewBox="0 0 11 14"><path d="m2 1 6 6-6 6" stroke="currentColor" stroke-width="3" fill="none"/></svg>`
		form.querySelectorAll('input.input--datefield').forEach((input) => {
			new Datepicker(input, {
				buttonClass: 'datepickerbutton',
				language: 'pl',
				weekStart: 1,
				format: 'dd / mm / yyyy',
				prevArrow: datePickerArrow,
				nextArrow: datePickerArrow,
				todayButton: true,
				autohide: true,
			});

			const {MaskInput} = Maska;
			new MaskInput(input);
		});

		// Handle from recover from localStorage
		recoverPersistedForm(form, store);
	});
})

function request_captcha(action) {
	return new Promise((resolve, reject) => {
		window['grecaptcha'].ready(function () {
			window['grecaptcha'].execute('6LdirN0kAAAAACqthbJaVQ02sN9mxJTsJcHUwctv', {
				action: action,
			})
			.then(resolve)
			.catch(reject);
		});
	})
}
